import { DateTime, Duration } from 'luxon';
import { Undefinable } from '../types';
import { getDateFormatLocale } from './date';

export const formatDateTimeForDisplay = (dateTime: DateTime): string => {
  const locale = getDateFormatLocale();
  return dateTime.setLocale(locale).toLocaleString(DateTime.DATETIME_SHORT);
};

export const formatDateTimePeriod = (start: Date, finish: Date, unit: 'short' | 'long' | 'narrow' = 'short'): string => {
  const duration = DateTime.fromJSDate(finish).diff(DateTime.fromJSDate(start));
  const normalized = duration.normalize();
  const { hours, minutes, seconds } = normalized.shiftTo('hours', 'minutes', 'seconds');
  const handleZero = (number: number): Undefinable<number> => number < 1 ? undefined : Math.round(number);
  return Duration.fromObject(
    {
      hours: handleZero(hours),
      minutes: handleZero(minutes),
      seconds: (hours < 1 && minutes < 1) ? handleZero(seconds) : undefined,
    },
    { locale: getDateFormatLocale() },
  ).toHuman({ unitDisplay: unit });
};
